import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import BASE_URL from '../config/config';
import { claves } from '../queries/cliente';
import { FiHeadphones, FiClock, FiCode, FiPenTool, FiTrendingUp, FiShare2, FiMessageCircle, FiCheckCircle } from 'react-icons/fi';

const Inicio = () => {
  const { t } = useTranslation();
  const [soporteDisponible, setSoporteDisponible] = useState(false);

  const token = localStorage.getItem("AuthToken");
  const logged = !!token;
  const navigate = useNavigate();

  const handleCreateTicket = (department) => {
    window.scrollTo(0, 0);
    if (logged) {
      navigate('/nuevo-ticket', { state: { department } });
    } else {
      navigate('/iniciar-sesion');
    }
  };

  // Horario de oficina: mismo dato (y misma caché) que usa "Nuevo ticket"
  const { data: horario = null } = useQuery({
    queryKey: claves.ajuste('horario'),
    queryFn: async () => (await axios.get(`${BASE_URL}/ajustes/horario`)).data?.ajuste?.valor || null,
    staleTime: 10 * 60_000,
  });

  // Calcular disponibilidad cuando el horario esté cargado
  useEffect(() => {
    if (!horario) return;

    const ahora = new Date();
    const dia = ahora.getDay();
    const horaDecimal = ahora.getHours() + ahora.getMinutes() / 60;

    const horaInicio = horario.hora_inicio ?? 8;
    const horaCierre = horario.hora_cierre ?? 16;
    const horaCierreViernes = horario.hora_cierre_viernes ?? 15;

    const esLaborable = dia >= 1 && dia <= 5;
    const cierreHoy = dia === 5 ? horaCierreViernes : horaCierre;

    setSoporteDisponible(esLaborable && horaDecimal >= horaInicio && horaDecimal < cierreHoy);
  }, [horario]);

  // Formatear el horario de hoy para mostrar en pantalla
  let textoHorario = t('comun.cargando');
  if (horario) {
    const dia = new Date().getDay();
    const horaInicio = horario.hora_inicio ?? 8;
    const horaCierre = horario.hora_cierre ?? 16;
    const horaCierreViernes = horario.hora_cierre_viernes ?? 15;
    const esLaborable = dia >= 1 && dia <= 5;
    const cierreHoy = dia === 5 ? horaCierreViernes : horaCierre;
    const nombreDia = t(`dias.${dia}`);

    textoHorario = esLaborable
      ? t('inicio.horarioHoy', { dia: nombreDia, inicio: horaInicio, cierre: cierreHoy })
      : t('inicio.horarioCerrado', { dia: nombreDia });
  }

  // Un solo bloque por departamento: el contenido vive en las traducciones
  const departamentos = [
    { clave: 'desarrollo', icono: FiCode },
    { clave: 'diseno', icono: FiPenTool },
    { clave: 'marketing', icono: FiTrendingUp },
    { clave: 'redes_sociales', icono: FiShare2 },
  ];

  return (
    <main className='inicio'>
      <div className="bg-intro">
        <div className="bg-intro-blob bg-intro-blob-1"></div>
        <div className='site-width'>
          <div className='intro'>
            <div className="intro-text">
              <h1>{t('inicio.heroTitulo')} <br/><span>{t('inicio.heroTituloResalte')}</span></h1>
              <p>{t('inicio.heroTexto')}</p>
            </div>
            <div className="intro-info">
              <div className="support-time">
                <span className="intro-icon"><FiHeadphones /></span>
                <div className="support-text">
                  <p>{t('inicio.soporteTecnico')}</p>
                  <p className='disponible'><span className='pulse-dot'></span>{t('inicio.activo')}</p>
                </div>
              </div>
              <div className="office-time">
                <span className="intro-icon"><FiClock /></span>
                <div className="office-text">
                  <p>{t('inicio.horarioOficina')}</p>
                  <p>{textoHorario}</p>
                </div>
              </div>
            </div>
          </div>

          {/* departamentos */}
          <div className="departments">
            {departamentos.map(({ clave, icono: Icono }) => (
              <div className="department" key={clave}>
                <span className="department-icon"><Icono /></span>
                <h2>{t(`inicio.departamentos.${clave}.titulo`)}</h2>
                <p>{t(`inicio.departamentos.${clave}.texto`)}</p>
                <button
                  className='token-ticket'
                  onClick={() => handleCreateTicket(clave)}
                >
                  {logged ? t('menu.crearTicket') : t('inicio.iniciaSesionParaTicket')}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* comunidad */}
      <div className='bg-comunidad'>
        <div className="site-width">
          <div className="comunidad">
            <div className="comunidad-img-wrapper">
              <img src="images/imagen-comunidad.svg" alt={t('inicio.imagenComunidad')} />
            </div>
            <div className='texto-comunidad'>
              <span className="comunidad-badge">{t('inicio.filosofia')}</span>
              <h2>{t('inicio.comunidadTitulo')} <span>{t('inicio.comunidadTituloResalte')}</span></h2>
              <p className="comunidad-lead">{t('inicio.comunidadTexto')}</p>
              <ul className="comunidad-features">
                <li>
                  <span className="comunidad-feature-icon"><FiMessageCircle /></span>
                  {t('inicio.ventaja1')}
                </li>
                <li>
                  <span className="comunidad-feature-icon"><FiClock /></span>
                  {t('inicio.ventaja2')}
                </li>
                <li>
                  <span className="comunidad-feature-icon"><FiHeadphones /></span>
                  {t('inicio.ventaja3')}
                </li>
                <li>
                  <span className="comunidad-feature-icon"><FiCheckCircle /></span>
                  {t('inicio.ventaja4')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Inicio;
